<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SiteHeader from '@/components/layout/SiteHeader.vue'
import SiteFooter from '@/components/layout/SiteFooter.vue'
import BackToTop from '@/components/ui/BackToTop.vue'

const { locale } = useI18n()

const rtlLocales = new Set(['ar', 'fa', 'he', 'ur'])

const dir = computed(() => rtlLocales.has(locale.value) ? 'rtl' : 'ltr')
const lang = computed(() => locale.value)
</script>

<template>
  <div :dir="dir" :lang="lang" class="min-h-screen flex flex-col">
    <SiteHeader />
    <main id="main-content" class="flex-1">
      <router-view />
    </main>
    <SiteFooter />
    <BackToTop />
  </div>
</template>
